import { Injectable } from "@angular/core";
import { apiPath, driverOperationsEndpoint } from "../../shared/api-path.const";
import { BackendBody } from "../../shared/backend-api.types";
import { ApiService } from "../http/api.service";

@Injectable({
  providedIn: "root",
})
export class DriverOperationsService {
  constructor(private readonly apiService: ApiService) {}

  public async schedule(orderId: string): Promise<void> {
    return this.sendOperation(orderId, driverOperationsEndpoint.schedule);
  }

  public async startPickup(orderId: string): Promise<void> {
    return this.sendOperation(orderId, driverOperationsEndpoint.startPickup);
  }

  public async startDelivery(orderId: string): Promise<void> {
    return this.sendOperation(orderId, driverOperationsEndpoint.startDelivery);
  }

  public async completeDelivery(orderId: string): Promise<void> {
    return this.sendOperation(orderId, driverOperationsEndpoint.completeDelivery);
  }

  public async uploadProofPhoto(orderId: string, pictureUrl: string): Promise<void> {
    const endpoint = `${apiPath.order}/${orderId}/${apiPath.driverOperations}/${driverOperationsEndpoint.uploadProofPhoto}`;
    await this.apiService.sendPostRequest<BackendBody["UploadProofPhotoRequest"], never>(endpoint, { pictureUrl });
  }

  private async sendOperation(orderId: string, operation: string): Promise<void> {
    const endpoint = `${apiPath.order}/${orderId}/${apiPath.driverOperations}/${operation}`;
    await this.apiService.sendPostRequest<undefined, never>(endpoint, undefined);
  }
}
